function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 36,
  height: 36,
  rx: 9.5,
  fill: "white",
  stroke: "black"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 15,
  r: 5.5,
  fill: "white",
  stroke: "black"
});
var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 36,
  height: 36,
  rx: 9.5,
  fill: "white",
  stroke: "black"
});
var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_2895_13240)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M31.5 38.0291C31.5 45.1451 25.8907 50.8902 19 50.8902C12.1093 50.8902 6.5 45.1451 6.5 38.0291C6.5 30.9131 12.1093 25.168 19 25.168C25.8907 25.168 31.5 30.9131 31.5 38.0291Z",
  fill: "white",
  stroke: "black"
}));
var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 36,
  height: 36,
  rx: 9.5,
  stroke: "black"
});
const SvgProfile = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2895_13240",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 37,
    height: 37
  }, _ref4), _ref5, _ref6);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProfile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/profile.04261ca2.svg";
export { ForwardRef as ReactComponent };